import { CertificationEntity } from '@eastcoal/api/auth/interface'

import { isEmpty } from '@eastcoal/common/utils/object'

export const resolveChangedValue = (
  formValue?: CertificationEntity[],
  changedValue?: CertificationEntity[]
) => {
  if (isEmpty(formValue)) {
    return changedValue ?? []
  }
  // 获取不在form中新增的value
  const newChangeValue = changedValue?.filter(
    item => !formValue?.map(value => value.id)?.includes(item.id)
  )
  // 更新form中相同id的value
  formValue?.forEach((value, index) => {
    const oldValue = changedValue?.find(item => item.id === value.id)
    if (!isEmpty(oldValue)) formValue.splice(index, 1, oldValue)
  })

  return formValue?.concat(newChangeValue ?? [])
}
